import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SidebarContext } from "../../../context/SidebarContext";
import SectionMenuLeft from "../../../components/SectionMenuLeft/SectionMenuLeft.jsx";
import { ToastContainer, toast } from "react-toastify";
import "./SubAdminUpdatePermissions.css";
import { config } from "../../../config.js";
import { useNavigate } from "react-router-dom";
import { LuArrowLeft } from "react-icons/lu";

function SubAdminUpdatePermissions() {
  const { isSidebar } = useContext(SidebarContext);
  const { uid } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [permissions, setPermissions] = useState({});
  const [subAdminName, setSubAdminName] = useState("");
  // Inside your component, after fetching permissions
  const [selectAll, setSelectAll] = useState(false);
  const navigate = useNavigate();

  // When permissions change, update selectAll state
  useEffect(() => {
    const allChecked = Object.values(permissions).every((val) => val === true);
    setSelectAll(allChecked);
  }, [permissions]);

  // Handle toggling select all
  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);

    const updated = Object.keys(permissions).reduce((acc, key) => {
      acc[key] = checked;
      return acc;
    }, {});
    setPermissions(updated);
  };

  //  Fetch sub-admin data
  const fetchSubAdmin = async (uid) => {
    setIsLoading(true);
    try {
      const response = await fetch(
        `${config?.backEndBaseUrl}sub-admin/read/${uid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status && result.sub_admin) {
        const subAdminData = Array.isArray(result.sub_admin)
          ? result.sub_admin[0]
          : result.sub_admin;

        setSubAdminName(subAdminData.name || "Unknown");
        setPermissions(subAdminData.permissions || {});
      } else {
        toast.error("Sub-admin not found");
      }
    } catch (error) {
      console.error("Fetching sub_admin failed:", error);
      toast.error("Failed to fetch sub-admin data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (uid) fetchSubAdmin(uid);
  }, [uid]);

  //  Handle toggle change
  const handleToggle = (e) => {
    const { name, checked } = e.target;
    setPermissions((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  //  Handle save
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsLoading(true);

      const response = await fetch(
        `${config?.backEndBaseUrl}sub-admin/permissions/update/${uid}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-dashboard-request": "true",
          },
          body: JSON.stringify({ permissions }), // ✅ Send JSON body
        },
      );

      const result = await response.json();

      if (response.ok && result.status) {
        toast.success("Permissions updated successfully!");
        setTimeout(() => {
          navigate("/admin/sub");
        }, 1000);
      } else {
        toast.error(result.message || "Failed to update permissions");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error updating permissions");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="body">
      <div id="wrapper">
        <div id="page">
          <div className="layout-wrap">
            <SectionMenuLeft />
            <div className="section-content-right">
              <div
                className="main-content"
                style={{ paddingLeft: isSidebar ? "280px" : "0px" }}
              >
                <div className="main-content-inner">
                  <div className="wg-box wg-box-container">
                    <ToastContainer />

                    <form onSubmit={handleSubmit}>
                      {/* <h4 style={{ fontWeight: '700' }} className='fromTitle'>
                                               
                                            </h4> */}

                      <div className="flex items-center justify-between mb-12 flex-wrap gap-3">
                        <div className="flex items-center gap-3">
                          <button
                            className="back-btn flex items-center gap-2"
                            onClick={() => navigate(-1)}
                          >
                            <LuArrowLeft size={16} />
                            {/* <span>Back</span> */}
                          </button>

                          <h5 className="fare-heading">
                            Sub Admin Name: {subAdminName}
                          </h5>
                        </div>
                      </div>

                      <div className="checkBxCon">
                        <div className="permissions-grid">
                          <fieldset className="select-all">
                            <div className="body-title">
                              Select All Permissions
                            </div>
                            <label className="switch">
                              <input
                                type="checkbox"
                                checked={selectAll}
                                onChange={handleSelectAll}
                              />
                              <span className="slider round"></span>
                            </label>
                          </fieldset>

                          {Object.entries(permissions)
                            .filter(([key]) => key !== "select_all")
                            .map(([key, value]) => (
                              <fieldset key={key}>
                                <div className="body-title">
                                  {key.replace(/_/g, " ")}
                                </div>
                                <label className="switch">
                                  <input
                                    type="checkbox"
                                    name={key}
                                    checked={!!value}
                                    onChange={handleToggle}
                                  />
                                  <span className="slider round"></span>
                                </label>
                              </fieldset>
                            ))}
                        </div>
                      </div>

                      <div className="subBtnCon">
                        <button
                          type="submit"
                          className="btn"
                          disabled={isLoading}
                        >
                          {isLoading ? "Saving..." : "Save"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SubAdminUpdatePermissions;
